import { render, staticRenderFns } from "./home-first-blog.vue?vue&type=template&id=795ddbfe&scoped=true&"
import script from "./home-first-blog.vue?vue&type=script&lang=js&"
export * from "./home-first-blog.vue?vue&type=script&lang=js&"
import style0 from "./home-first-blog.vue?vue&type=style&index=0&id=795ddbfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ddbfe",
  null
  
)

export default component.exports